import { Component, OnInit } from '@angular/core';
import { HeaderTitleService } from '../../services/title.service';

@Component({
  selector: 'app-header-title',
  templateUrl: './header-title.component.html',
  styleUrls: ['./header-title.component.css']
})
export class HeaderTitleComponent implements OnInit {

  constructor(
    private headerTitleService: HeaderTitleService,
  ) {
  }

  ngOnInit() {
  }

  get title(): string {
    return this.headerTitleService.titleName;
  }

  get isShowTitle(): boolean {
    return this.headerTitleService.isVisibleTitle && !!this.title;
  }
}
